import { Button, Card, Group, Modal, Stack, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';

export interface ShareModalProps {
  opened: boolean;
  onClose: () => void;
  text: string;
  title: string;
  listingUrl?: string;
}

export function ShareModal(props: ShareModalProps): JSX.Element {
  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(props.text)}`;
  const handleCopy = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(props.text);
      notifications.show({ message: 'Text kopiert', color: 'green' });
    } catch {
      notifications.show({ message: 'Clipboard nicht verfügbar', color: 'red' });
    }
  };

  return (
    <Modal
      opened={props.opened}
      onClose={props.onClose}
      title="★ An Partner senden?"
      centered
      size="md"
      radius="lg"
    >
      <Stack gap="md">
        <Text size="sm" fw={500}>
          {props.title}
        </Text>
        <Card withBorder padding="sm">
          <Text size="sm" style={{ whiteSpace: 'pre-line' }}>
            {props.text}
          </Text>
        </Card>
        <Group gap="xs" grow>
          <Button
            component="a"
            href={whatsappUrl}
            target="_blank"
            rel="noreferrer"
            color="green"
            size="md"
            leftSection="📱"
          >
            WhatsApp öffnen
          </Button>
          <Button variant="light" onClick={handleCopy} leftSection="📋">
            Text kopieren
          </Button>
        </Group>
        {props.listingUrl && (
          <Text size="xs" c="dimmed" ta="center">
            <a href={props.listingUrl} target="_blank" rel="noreferrer">
              Inserat-Link direkt teilen?
            </a>
          </Text>
        )}
        <Button variant="subtle" color="gray" onClick={props.onClose}>
          Schließen
        </Button>
      </Stack>
    </Modal>
  );
}
